import { Layout } from 'antd';

const { Content } = Layout;

// Layout para el e-commerce público
const MinimumLayout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {

  return (
    <Layout style={{ minHeight: '100vh' }}>
        <Content style={{ padding: '1rem' }}>{children}</Content>
    </Layout>
  );
};

export default MinimumLayout;
